import TopicName from './TopicName';

export default TopicName;
